import { store, getContext } from '@wordpress/interactivity';

export const LOCAL_STORAGE_KEY = 'MEDIAPRESS_POLL_VOTES';

const { callbacks } = store('mediapress-polls', {
  callbacks: {
    /**
     * Retrieves the user's votes from local storage.
     *
     * @return {Array} Array of votes from local storage
     */
    getLocalVotes: () => {
      const userVotes = localStorage.getItem(LOCAL_STORAGE_KEY);
      return JSON.parse(userVotes) || [];
    },
    /**
     * Checks if the user has already voted in the poll.
     *
     * @return {void}
     */
    checkUserHasVoted: () => {
      const context = getContext();
      const { pollId } = context;

      const existingVotes = callbacks.getLocalVotes();

      const existingVote = existingVotes.find((vote) => vote.pollId === pollId);
      if (!existingVote) {
        return;
      }

      const { optionId } = existingVote;

      context.selectedOptionId = optionId;
      context.showResult = true;
    },
  },
});
